<template>
	<div class="ui--gallery" aria-label role="text" tabindex="0" ref="ref">
		<div class="button--close" role="button" @click="close" />
		<Swiper
			ref="swiperComponent"
			:options="swiperOptions"
			@click-slide="onClickSlide"
			@slideChange="onSlideChange"
		>
			<Slide v-for="element in elements" :key="element.id" :mediaObject="element" />
			<div
				v-if="elements.length > 1 && activeIndex < elements.length - 1"
				class="button--slide button--next"
				@click="next()"
				slot="button-next"
			></div>
			<div
				v-if="elements.length > 1 && activeIndex > 0"
				class="button--slide button--prev"
				@click="prev()"
				slot="button-next"
			></div>
			<div v-if="elements.length > 1" class="pagination" slot="pagination">
				<div
					v-for="(slide, index) in elements"
					:key="slide.id"
					class="pagination--dot"
					:class="{ active: index === activeIndex }"
					@click="() => slideTo(index)"
				/>
			</div>
		</Swiper>
	</div>
</template>
<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Swiper } from 'vue-awesome-swiper';
import Slide from './Slide.vue';

export default {
	name: 'Gallery',
	props: {},
	components: {
		Swiper,
		Slide,
	},
	data() {
		return {
			swiperOptions: {
				slidesPerView: 'auto',
				centeredSlides: true,
			},
			activeIndex: 0,
			zoomObject: null,
			showZoom: false,
		};
	},
	computed: {
		swiper() {
			return this.$refs.swiperComponent.$swiper;
		},
		elements() {
			return this.$store.getters.getGalleryImages || [];
		},
	},
	methods: {
		onClickSlide(index, reallyIndex) {
			this.zoomedMediaObject = this.elements[reallyIndex];
			this.toggleZoom();
		},
		prev() {
			this.swiper.slidePrev();
		},
		next() {
			this.swiper.slideNext();
		},
		slideTo(index) {
			this.swiper.slideTo(index);
		},
		onSlideChange() {
			this.activeIndex = this.swiper.realIndex;
		},
		toggleZoom() {
			this.$store.dispatch('openZoom', this.elements[this.activeIndex].BtnId);
		},
		close() {
			this.$store.dispatch('closeGallery');
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.swiper.update();
			disableBodyScroll(this.$refs.ref);
		});
	},
	beforeDestroy() {
		enableBodyScroll(this.$refs.ref);
	},
};
</script>
